/**
 * 工单每日数量走势组件
 */

import { useEffect, useState } from 'react';
import { Chart } from '@antv/g2';
import $ from 'jquery';
import {
    UjoinParams,
    AddRequestHeaders,
} from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

const WOWTCD = (props) => {
    const [isRefresh, setIsRefresh] = useState(true);
    const [data, setData] = useState([]);

    useEffect(() => {
        if (props.data) {
            setData(props.data);
        } else {
            if (isRefresh) {
                // 获取数据
                const params = {
                    'time_interval': 180,
                }
                $.ajax({
                    url: `${CNF.plmsApi}reports/wo/wtcd${UjoinParams(params)}`,
                    headers: AddRequestHeaders(),
                    crossDomain: true,
                    type: 'GET',
                    dataType: 'JSON', success: function (data) {
                        if (data.res === 0) {
                            setData(data.dat);
                            setIsRefresh(false);
                        }
                    }
                })
            }
        }
    }, [props, isRefresh]);

    useEffect(() => {
        const chart = new Chart({
            container: 'antv-g2-id-wowtcd',
            autoFit: true,
        });

        chart.data(data);

        chart
            .line()
            .encode('x', 'date')
            .encode('y', 'count')
            .encode('shape', 'smooth')
            .scale('y', { independent: true })
            .scale('y', { nice: true })
            .scale('color', {
                range: CNF.swatches[CNF.currentSwatche],
            })
            .axis('x', { title: '日期', })
            .axis('y', {
                title: null,
                labelFormatter: (d) => `${d > 10000 ? (d / 10000).toFixed(CNF.DPL) : d}`
            })
            .animate('enter', {
                type: 'pathIn',
                duration: CNF.animateDuration + 1000,
            },)
            .tooltip({
                items: [
                    (d) => {
                        return { channel: 'y', value: `${d.count}个`, }
                    },
                ],
            })
            .style('lineWidth', 1)
            .style('stroke', global.THEMECOLOR);

        chart.render();

        return () => {
            chart.destroy();
        }
    }, [props, data]);

    return <div id='antv-g2-id-wowtcd'></div>
}

export default WOWTCD;